<template>
  <div class="line-chart-container pt-5 pr-5">
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :width="width"
      :height="height"
    />

    <!-- Custom Legend -->
    <div class="custom-legend">
      <div 
        v-for="(dataset, index) in chartData.datasets" 
        :key="index" 
        class="legend-item"
      >
        <div
          class="legend-box"
          :style="{ backgroundColor: dataset.borderColor }"
        ></div>
        <span class="legend-label">{{ dataset.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  ChartDataLabels
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: { type: String, default: "line-chart" },
    datasetIdKey: { type: String, default: "label" },
    width: { type: Number, default: 400 },
    height: { type: Number, default: 400 },
    cssClasses: { default: "", type: String },
    styles: { type: Object, default: () => {} },
    plugins: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
    datasets: { type: Array, default: () => [] },
  },

  computed: {
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false, // ❌ Disable Chart.js legend
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: { display: false },
            beginAtZero: true,
          },
          y: {
            grid: { display: false },
            beginAtZero: true,
          },
        },
      };
    },
  },

  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: this.datasets,
      },
    };
  },

  watch: {
    labels(newLabels) {
      this.chartData.labels = newLabels;
      this.$forceUpdate();
    },
    datasets(newDatasets) {
      this.chartData.datasets = newDatasets;
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.line-chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: auto;
  position: relative;
}

.custom-legend {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 16px 0;
  flex-wrap: wrap;
  margin-top: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.legend-box {
  width: 20px;
  height: 14px;
  border-radius: 3px; /* Curvy rectangle */
  flex-shrink: 0;
}

.legend-label {
  font-size: 12px;
  font-family: "GraphikMedium", sans-serif !important;
  font-weight: 500;
  color: #333;
}
</style>
